import { updatePaymentForm } from 'redux/actions/paymentForm';
import {
  CLEAR_FORM_ACTION,
  FORM_ACTION,
  GET_SINGLE_FORM,
  GET_TERMINAL_NAMES,
} from 'redux/actions/types';

const initialState = {
  createNewForm: [],
  isLoading: true,
};

const formActions = (state = initialState, { type, data }) => {
  switch (type) {
    case FORM_ACTION:
      return {
        ...state,
        formData: data,
      };
    case GET_TERMINAL_NAMES:
      return {
        ...state,
        terminalNames: data,
      };
    case GET_SINGLE_FORM:
      return {
        ...state,
        singleForm: data,
      };
    case CLEAR_FORM_ACTION:
      return {
        isLoading: true,
      };
    default:
      return state;
  }
};

export default formActions;
